module.exports = __webpack_public_path__ + "img/watchap.8a55993b.svg";